<template>
  <v-sheet class="json-viewer" color="grey-lighten-5" rounded border>
    <pre :style="{ maxHeight: maxHeight + 'px' }">{{ formatted }}</pre>
  </v-sheet>
</template>

<script>
export default {
  name: 'JsonViewer',
  props: {
    value: {
      type: [Object, Array, String, Number, Boolean, null],
      default: () => null,
    },
    maxHeight: {
      type: Number,
      default: 400,
    },
  },
  computed: {
    formatted() {
      if (this.value === undefined || this.value === null) return 'No Data Available'
      if (typeof this.value === 'string') {
        try {
          const parsed = JSON.parse(this.value)
          return JSON.stringify(parsed, null, 2)
        } catch (e) {
          return this.value
        }
      }
      return JSON.stringify(this.value, null, 2)
    },
  },
}
</script>

<style scoped>
.json-viewer {
  padding: 10px;
}

pre {
  margin: 0;
  font-family: Consolas, Menlo, Monaco, "Courier New", monospace;
  font-size: 0.85rem;
  white-space: pre-wrap;
  word-break: break-word;
  overflow: auto;
}
</style>
